import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const fileRequests = {}

fileRequests.CheckAcceptanceConfirm = (data) => {
  return axios.post(
    AppUrls.CheckAcceptanceConfirm,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.UpdateMetadata = (data) => {
  return axios.post(
    AppUrls.UpdateMetadata,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.GetFileByGUID = (data) => {
  return axios.post(
    AppUrls.getFileByGUID,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

fileRequests.GetFileInfo = (data) => {
  return axios.post(
    AppUrls.GetFileInfo,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.GetTextEvidence = (data) => {
  return axios.post(
    AppUrls.GetTextEvidence,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.GenerateFolioChildWorkflow = (data) => {
  return axios.post(
    AppUrls.GenerateFolioChildWorkflow,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

fileRequests.GenerateFolioRemote = (data) => {
  return axios.post(
    AppUrls.GenerateFolioRemote,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

fileRequests.CheckDeAceptacionPDF = (data) => {
  return axios.post(
    AppUrls.checkDeAceptacionPDF,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.SetOptionsToSelect = (data) => {
  return axios.post(
    AppUrls.SetOptionsToSelect,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.GetFilesSearch = (data) => {
  return axios.post(
    AppUrls.GetFilesSearch,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.GenerateFolio = (data) => {
  return axios.post(
    AppUrls.GenerateFolio,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.GetActorByGroup = (data) => {
  return axios.post(
    AppUrls.GetActorByGroup,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.GetActors = (data) => {
  return axios.post(
    AppUrls.GetActors,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.SetGroupName = (data) => {
  return axios.post(
    AppUrls.SetGroupName,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.RegisterActor = (data) => {
  return axios.post(
    AppUrls.RegisterActor,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.StartActorFlow = (data) => {
  return axios.post(
    AppUrls.StartActorFlow,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.RemoveActor = (data) => {
  return axios.post(
    AppUrls.RemoveActor,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.UpdateActorsRole = (data) => {
  return axios.post(
    AppUrls.UpdateActorsRole,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.SetManualConfigurations = (data) => {
  // console.log("entrada------SetManualConfigurations--------", data)
  return axios.post(
    AppUrls.SetManualConfigurations,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.ContinueStageActorSelection = (data) => {
  return axios.post(
    AppUrls.ContinueStageActorSelection,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.GetFileInfoByFolio = (data) => {
  return axios.post(
    AppUrls.GetFileInfoByFolio,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileRequests.GenerateFolioExterno = (data) => {
  return axios.post(
    AppUrls.GenerateFolioExterno,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

fileRequests.RegisterSurveyAnswers = (data) => {
  return axios
    .post(AppUrls.RegisterSurveyAnswers, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};

fileRequests.GetSurveyQuestions = (data) => {
  return axios
    .post(AppUrls.GetSurveyQuestions, Config.SetParameters(data, '', '', ''), Config.ConfigAuth())
    .then(handleResponse);
};


let handleResponse = (response) => {
  // console.log("salida------SetManualConfigurations--------", response)
  let respObject = response.data;//BodySecurityResponse(response.data);

  let stageCurrent = response.data.Body?.Stage
  // console.log("*******File INFO------response.data--------*****: ", response.data.Body)
  // console.log("*******File INFO------stageCurrent--------*****: ", stageCurrent)
  if (stageCurrent != undefined && stageCurrent != null) {
    // console.log("*******File INFO------stageCurrent--------*****: ", stageCurrent)
    // console.log("barra: ", stageCurrent?.TotalStageGroups, stageCurrent?.CurrentStageGroup)
    localStorage.setItem("TotalStageGroups", stageCurrent?.TotalStageGroups)
    localStorage.setItem("CurrentStageGroup", stageCurrent?.CurrentStageGroup)
    // setTotalStage(stageCurrent?.TotalStageGroups);
    // setCurrentStage(stageCurrent?.CurrentStageGroup);
  }

  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}